import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import {
  FilterItemNoResults,
  FiltersMenu,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconTools from '@/icons/Tools.svg';
import { ARTICLE_SERVICE_TYPES } from '@/models/article';

import { useFilters } from '../FiltersState';
import { useServiceTypeOptions } from '../utils';

export const FiltersServiceType = ({ tag }: { tag?: boolean }) => {
  const { t, i18n } = useLingui();

  const {
    serviceTypes: { serviceTypes, setServiceTypes },
  } = useFilters();

  const serviceTypeOptions = useServiceTypeOptions();

  const options =
    serviceTypeOptions.length > 0 ? (
      serviceTypeOptions.map(({ id, label }) => (
        <FilterCheckboxItem
          key={id}
          checked={serviceTypes.includes(id)}
          onChange={(checked) => {
            if (checked) {
              setServiceTypes([...serviceTypes, id]);
            } else {
              setServiceTypes(serviceTypes.filter((task) => task !== id));
            }
          }}
        >
          {i18n._(label)}
        </FilterCheckboxItem>
      ))
    ) : (
      <FilterItemNoResults />
    );

  if (tag) {
    if (serviceTypes.length === 0) {
      return null;
    }

    const numberOfServiceTypes = serviceTypes.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'requests.filters.service-type.label', message: 'Service type' })}
            value={
              serviceTypes.length === 1 ? (
                i18n._(
                  ARTICLE_SERVICE_TYPES.find((serviceType) => serviceType.id === serviceTypes[0])!
                    .label
                )
              ) : (
                <Trans id="requests.filters.service-type.multiple">
                  {numberOfServiceTypes} service types
                </Trans>
              )
            }
            tooltip={
              serviceTypes.length > 1
                ? serviceTypes
                    .map((serviceType) =>
                      i18n._(ARTICLE_SERVICE_TYPES.find((st) => st.id === serviceType)!.label)
                    )
                    .join(', ')
                : undefined
            }
            onClear={() => setServiceTypes([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconTools />}
      label={t({ id: 'requests.filters.service-type.label', message: 'Service type' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
